module.exports = __webpack_public_path__ + "static/media/img_Benchmarking303.5f32afc5.png";